<template>
    <div>
        <v-breadcrumbs :items="breadcrumbs" divider="-" class="hidden-sm-and-down">
            <v-breadcrumbs-item
                    slot="item"
                    slot-scope="{ item }"
                    exact
                    :to="item.href">
                <span :class="itemClasses(item)">{{ item.text }}</span>
            </v-breadcrumbs-item>
        </v-breadcrumbs>


        <v-breadcrumbs v-if="productData" :items="breadcrumbs" divider="-" class="hidden-sm-and-up justify-center">
            <v-breadcrumbs-item
                    slot="item"
                    slot-scope="{ item }"
                    exact
                    :to="item.href">
                <span :class="itemClasses(item)">{{ item.text }}</span>
            </v-breadcrumbs-item>
        </v-breadcrumbs>
    </div>

</template>

<script>
    export default {
        name: "Breadcrumbs",
        props: ['breadcrumbs', 'productData'],
        methods: {
            itemClasses(item) {
                return [
                    'text-uppercase caption',
                    item.disabled ? 'grey--text' : 'text-underline black--text',
                ].join(' ');
            },
        },
    }
</script>

<style scoped>

</style>
